import React, { useState, useEffect } from 'react'
import pathname from '../../constants/pathname'
import ProjectDataTable from '../dataTable/ProjectDataTable'
import { useHistory } from 'react-router-dom'
import { getWaitInitialScreening } from '../../redux/actions/dashboard'
import DashboradToggle from './DashboradToggle'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function WaitScreeningInitial({ config, onSettingChange = () => {} }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  let history = useHistory()

  // let id = location.search.substring(1)
  let id = sessionStorage.getItem('param')?.substring(1)

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handelGetSchemaDashboard(5, 1)
    }
  }, [])

  const handelGetSchemaDashboard = async (
    pagesize,
    pagenumber,
    projectCodeSearch,
    projectNameSearch
  ) => {
    setLoading(true)
    // startLoading()
    try {
      const response = await getWaitInitialScreening(
        pagesize,
        pagenumber,
        projectCodeSearch,
        projectNameSearch
      )
      setSchema(response)
    } catch (e) {
      setError({})
    }
    // doneLoading()
    setLoading(false)
  }

  const onMultiSubmit = (selectList) => {
    console.log('WaitForScrutinize onSubmit', selectList)

    let idList = selectList.map((element) => {
      return element.id
    })

    sessionStorage.setItem('mutiReview', idList)
    sessionStorage.setItem('projectId', 'multi-reveiw')
    sessionStorage.setItem('param', '')

    return history.push({
      pathname: `${pathname.proposal.review.projectList}`,
      state: { selectId: idList },
    })
  }

  const onSingleSubmit = (obj) => {
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem('param', '')
    // console.log('id', obj.ig)
    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}
          <ProjectDataTable
            schema={schema}
            subName={{ enable: true }}
            multi={{ enable: false, buttonText: 'ไปยังการคัดกรอง' }}
            single={{
              enable: true,
              buttonText: schema?.buttonText,
              icon: schema?.singleIcon,
            }}
            onSingleSubmit={onSingleSubmit}
            onMultiSubmit={onMultiSubmit}
            pagination={true}
            onReload={handelGetSchemaDashboard}
            loading={loading}
            searchEnable={true}
            setting={config && true}
          />
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'โครงการที่รอคัดกรองขั้นต้น',
  projectCodeText: 'รหัสโครงการ',
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectBudgetText: 'งบประมาณรวม',
  buttonText: 'คัดกรอง',
  totalSize: 1,
  values: [
    {
      id: '',
      projectCode: 'XX-XXXXX',
      projectName: {
        name: 'โครงการ XXXXX',
        statusName: 'ยื่นข้อเสนอโครงการแล้ว - รอคัดกรองขั้นต้น',
      },
      projectBudget: '9,999,999.99',
      projectType: { value: 'โครงการ', label: '1' },
    },
  ],
}
